import moment from "moment"
import "moment/locale/es"
import enUSDatePickerLocale from "antd/es/date-picker/locale/en_US"
import esESDatePickerLocale from "antd/es/date-picker/locale/es_ES"
import {store} from "helpers/storage"
import {Auth} from "types/auth"

/** Dedicated moment locales used by BaseDatePicker / BaseRangePicker (week start only). */
const EDULAR_LOCALE_EN = "edular"
const EDULAR_LOCALE_ES = "edular-es"

function ensureEdularLocale(name: string, parentLocale: string, week: {dow: number; doy: number}) {
    const locales = moment.locales()

    if (locales.includes(name)) {
        moment.updateLocale(name, {week})
        return
    }

    const previous = moment.locale()
    moment.defineLocale(name, {parentLocale, week})
    moment.locale(previous)
}

/**
 * Set Ant Design DatePicker week start (0=Sun … 6=Sat).
 * DatePicker reads firstDayOfWeek from moment().locale(lang.locale).
 */
export function syncAntdMomentWeekStart(dow: number) {
    const week = {dow, doy: 6}

    ensureEdularLocale(EDULAR_LOCALE_EN, "en", week)
    ensureEdularLocale(EDULAR_LOCALE_ES, "es", week)

    moment.updateLocale("en", {week})
}

/** Ant Design DatePicker/RangePicker locale bound to the edular week-start locale. */
export function getAntdDatePickerLocale(dow: number) {
    syncAntdMomentWeekStart(dow)

    const isSpanish = (store.get("locale") || Auth.DisplayLanguage.English) === Auth.DisplayLanguage.Spanish
    const base = isSpanish ? esESDatePickerLocale : enUSDatePickerLocale

    return {
        ...base,
        lang: {
            ...base.lang,
            locale: isSpanish ? EDULAR_LOCALE_ES : EDULAR_LOCALE_EN
        }
    }
}
